import router from "./router";
import i18n from "./i18n";

export const partnersModuleRouter = router;
export const partnersModuleI18n = i18n;
